<template>
  <div class="newsfeed-settings-page">
    <div class="newsfeed-settings-page__title">{{ $t('settings.news_settings') }}</div>
    <div
      class="newsfeed-settings-page__subtitle"
    >{{ $t('settings.manage_subscriptions_news') }}</div>
    <newsfeed-settings></newsfeed-settings>
  </div>
</template>
<script>
  import newsfeedSettings from '@/components/Settings/newsfeed.vue';

  export default {
    name: 'newsfeedSettingsPage',
    components: {newsfeedSettings}
  }
</script>
<style lang="scss">
.newsfeed-settings-page {
  max-width: 500px;
  padding: 25px 20px;
  background: #fff;
  box-shadow: 0px 4px 20px rgba(53, 49, 81, 0.06);
  border-radius: 12px;

  &__title {
    margin-bottom: 9px;
    font-size: 18px;
    font-weight: 700;
  }
  &__subtitle {
    margin-bottom: 25px;
    color: #838A99;
    font-weight: 500;
  }
}
</style>